export const buildDossierSummaryPath = (fileId: string): string => `/dossier/${fileId}/summary`;

export const buildCommandePath = (orderId: string): string => `/commande?orderId=${orderId}`;
